// TODO move to kit

const UUID_V4_REGEX =
  /^[a-fA-F0-9]{8}-[a-fA-F0-9]{4}-[a-fA-F0-9]{4}-[a-fA-F0-9]{4}-[a-fA-F0-9]{12}$/;

export function isUUid(str?: any) {
  return typeof str === 'string' && UUID_V4_REGEX.test(str);
}
